exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tablefield p.emptyMessage{\r\n    padding: 10px;\r\n}\r\n\r\n.tablefield td:hover{\r\n    background-color:#d0e1f9;\r\n}\r\n\r\n.Table .movehandler{\r\n    display: none;\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top:0;\r\n    left:0;\r\n}\r\n\r\n.Table:hover .movehandler{\r\n    display: block;\r\n}\r\n\r\n.Table .movehandler:hover{\r\n    color:red;\r\n}\r\n\r\n\r\n.tablefield td.selected{\r\n    background-color:#d0e1f9;\r\n}\r\n\r\ntable.tablefield>tbody>tr> td.dragzone{\r\n    border:3px solid red !important;\r\n}\r\n", ""]);

// exports
